/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */

export interface ChangePasswordDTO {
  /**
   * New password
   * @maxLength 100
   */
  password: string;
  /** Confirm new password (must match the password field) */
  confirmPassword: string;
}
